<template>
  <async-loader v-if="cloudCannonContentLoading"/>
  <div v-else>
    <page-title>
      Resources
    </page-title>

    <cloud-cannon-content
      class="_p0 _ptxs"
      :content-loading="cloudCannonContentLoading"
      :content="cloudCannonContent.header"
    />

    <resources
      v-for="(resource, i) in cloudCannonResources" :key="i"
      :resource="resource"
      :index="i"/>

    <cloud-cannon-content
      class="_p0"
      :content-loading="cloudCannonContentLoading"
      :content="cloudCannonContent.footer"
    />
  </div>
</template>
<script>
  import Resources from './components/Resources.vue'
  import PageTitle from './components/PageTitle'
  import CloudCannonable from '@mixins/CloudCannonable'
  import fetchable from '@mixins/fetchable'
  import AsyncLoader from '@molecules/AsyncLoader'

  export default {
    components: {
      AsyncLoader,
      PageTitle,
      Resources
    },
    mixins: [
      fetchable,
      CloudCannonable
    ],
    data() {
      return {
        resources: [],
        fetchers: [
          {
            action: 'cloudCannon/GET_CLOUD_CANNON_CONTENT',
            options: {
              cloudCannonResource: '/resources.json'
            },
            config: {
              root: true
            }
          }
        ]
      }
    },
    computed: {
      cloudCannonResources () {
        return this
          .cloudCannonContent
          .resources
          .map(resource => {
            return {
              cat: resource.resource_name,
              color: resource.color,
              resources: resource.files.map(file => {
                return {
                  fileName: file.name,
                  url: file.url,
                  filePath: file.filePath
                }
              })
            }
          })
      }
    },
    updated() {
      // if there is a scrollTo query string in the URL, jump to any document or section with
      // that name
      this.$nextTick(() => {
        const scrollTo = this.$route.query.scrollTo
        if (scrollTo) {
          try {
            const allResourceHeaders = Array.from(document.querySelectorAll('.resources h3, .resources .filename'))
            const resourceHeadersThatMatch = allResourceHeaders.filter(div => div.innerText.toLowerCase() === scrollTo.toLowerCase())

            resourceHeadersThatMatch[0].scrollIntoView()
          } catch (error) {
            console.error(error)
          }
        }
      })
    }
  }
</script>
